<template>
  <div class="travelPolicy container">
    <div class="text-2xl font-bold text-center mt-32">{{ $t('taiwanTravel.ruleTitle') }}</div>
    <ol class="rule__content mt-32">
      <template v-for="i in Object.keys($t('taiwanTravel.ruleContent'))">
        <li :key="i">{{ $t(`taiwanTravel.ruleContent[${i}]`) }}<a v-if="i === '8'" :href="travelUrl" class="text-blue font-bold no-underline" target="_blank">https://1000.taiwan.net.tw/</a><span v-if="i === '8'">。</span>
        </li>
      </template>
    </ol>
    <div class="w-full text-center mt-40 mb-24">
      <a class="btn btn-solid btn-blue-light py-8 px-16 no-underline mx-auto" :href="travelUrl" target="_blank">
        {{ $t('taiwanTravel.travelLink') }}
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'taiwanTravelPolicy',
  data () {
    return {
      travelUrl: 'https://1000.taiwan.net.tw/'
    }
  }
}
</script>
<style lang="sass" scoped>
  p
    @apply leading-xl
  .rule__content, .card__content
    @apply text-grey-darker
    line-height: 1.5
    white-space: pre-wrap
  .rule__content
    padding-inline-start: 1rem
    >li
      @apply mt-8
</style>
